import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { isRouteBlockedForScopedUser, myDirectorateReportPath } from "../lib/directorateScope";

/** يمنع مستخدم المديرية من صفحات الملخصات العامة ويوجّهه لتقرير مديريته */
export default function DirectorateScopeRedirect({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (isRouteBlockedForScopedUser(pathname, user)) {
    const to = myDirectorateReportPath(user) ?? "/";
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
}
